/* eslint-disable no-confusing-arrow, no-nested-ternary, comma-dangle, no-unneeded-ternary, max-len */
import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

export const ARGOS_LOCKS_EVENTS_REQUEST = 'ARGOS_LOCKS_EVENTS_REQUEST';
export const ARGOS_LOCKS_EVENTS_SUCCESS = 'ARGOS_LOCKS_EVENTS_SUCCESS';
export const ARGOS_LOCKS_EVENTS_FAIL = 'ARGOS_LOCKS_EVENTS_FAIL';

export const ARGOS_EVENTS_TYPES_REQUEST = 'ARGOS_EVENTS_TYPES_REQUEST';
export const ARGOS_EVENTS_TYPES_SUCCESS = 'ARGOS_EVENTS_TYPES_SUCCESS';
export const ARGOS_EVENTS_TYPES_FAIL = 'ARGOS_EVENTS_TYPES_FAIL';

export const ARGOS_EVENTS_REQUEST = 'ARGOS_EVENTS_REQUEST';
export const ARGOS_EVENTS_SUCCESS = 'ARGOS_EVENTS_SUCCESS';
export const ARGOS_EVENTS_FAIL = 'ARGOS_EVENTS_FAIL';

export const ARGOS_LOCKS_REQUEST = 'ARGOS_LOCKS_REQUEST';
export const ARGOS_LOCKS_SUCCESS = 'ARGOS_LOCKS_SUCCESS';
export const ARGOS_LOCKS_FAIL = 'ARGOS_LOCKS_FAIL';

const argosLocksEventsRequest = () => ({ type: ARGOS_LOCKS_EVENTS_REQUEST });
const argosLocksEventsSuccess = (payload) => ({ type: ARGOS_LOCKS_EVENTS_SUCCESS, payload });
const argosLocksEventsFail = () => ({ type: ARGOS_LOCKS_EVENTS_FAIL });

const argosEventsTypesRequest = () => ({ type: ARGOS_EVENTS_TYPES_REQUEST });
const argosEventsTypesSuccess = (types) => ({ type: ARGOS_EVENTS_TYPES_SUCCESS, types });
const argosEventsTypesFail = () => ({ type: ARGOS_EVENTS_TYPES_FAIL });

const argosLocksRequest = () => ({ type: ARGOS_LOCKS_REQUEST });
const argosLocksSuccess = (locks) => ({ type: ARGOS_LOCKS_SUCCESS, locks });
const argosLocksFail = () => ({ type: ARGOS_LOCKS_FAIL });

const argosEventsRequest = () => ({ type: ARGOS_EVENTS_REQUEST });
const argosEventsSuccess = (report) => ({ type: ARGOS_EVENTS_SUCCESS, report });
const argosEventsFail = () => ({ type: ARGOS_EVENTS_FAIL });

export const loadArgosLocksEvents = (params) => (dispatch) => {
  dispatch(argosLocksEventsRequest());
  return communicate({ url: 'ArgosLogs', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then(({ data, ...other }) => {
      dispatch(argosLocksEventsSuccess(data?.Data || []));
    })
    .catch((err) => {
      dispatch(argosLocksEventsFail());
      toastrError(err);
    });
};

export const loadArgosEventsTypes = () => (dispatch) => {
  dispatch(argosEventsTypesRequest());
  return communicate({ url: 'Argos/Events/ArgosEventTypes' })
    .then(({ data }) => {
      dispatch(argosEventsTypesSuccess(data));
    })
    .catch((err) => {
      dispatch(argosEventsTypesFail());
      toastrError(err);
    });
};

export const loadArgosLocks = () => (dispatch) => {
  dispatch(argosLocksRequest());
  return communicate({ url: 'Argos/Locks' })
    .then(({ data }) => {
      dispatch(argosLocksSuccess(data));
    })
    .catch((err) => {
      dispatch(argosLocksFail());
      toastrError(err);
    });
};

export const loadArgosEvents = (params) => (dispatch) => {
  dispatch(argosEventsRequest());
  return communicate({
    url: 'Argos/Events',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then(({ data }) => {
      dispatch(argosEventsSuccess(data));
    })
    .catch((err) => {
      dispatch(argosEventsFail());
      toastrError(err);
    });
};
